import React, { Fragment } from 'react'

const NavigationDesktop = ({ links = [], contentLink = null }) => {
    let menuRef = React.createRef()
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null
    const hasChildrenClass = links.length > 0 ? 'has-children' : null
    
    return (
        <Fragment>
            {contentLink && (
                <Fragment>
                    <a
                        className={`navbar-desktop__link ${hasChildrenClass || ''} ${
                            additionClass || ''
                        }`}
                        href={contentLink.url || '#'}
                        dangerouslySetInnerHTML={{ __html: contentLink.name }}
                    ></a>
                </Fragment>
            )}
            {links.length > 0 && (
                <ul className="navbar-desktop__menu" ref={menuRef}>
                    {links.length > 0 &&
                        links.map((link, i) =>
                            !link.name ? null : (
                                <li
                                    className="navbar-desktop__item"
                                    key={`${link.name}-${i}`}
                                >
                                    <NavigationDesktop
                                        links={link.links}
                                        contentLink={link}
                                    />
                                </li>
                            )
                        )}
                </ul>
            )}
        </Fragment>
    )
}

export default NavigationDesktop
